@if (question$ | async; as question) {
  <lib-question-display [question]="question.value" />
  <p class="subtitle">Selecteer het aantal gewenste sterren</p>
  <lib-star-control
    [halfStar]="false"
    [maxRating]="question.scaleRange.totalSteps()"
    [formControl]="starCtrl"
  />
  <lib-scale-question-labels [questionData]="question" />
}
